import React from 'react';
import { motion } from 'framer-motion';

const ZoneCard = ({ zone, index, totalZones = 5 }) => {
  // Calculate progress bar width dynamically based on number of zones
  // We ensure it doesn't exceed 100%
  const progressWidth = Math.min(100, (index + 1) * (100 / totalZones));
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      className="group relative overflow-hidden bg-white border border-gray-200 rounded-lg p-5 hover:border-gray-400 hover:shadow-md transition-all duration-300"
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 relative z-10">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 text-gray-900 font-semibold text-lg border border-gray-200 shrink-0">
            {zone.number}
          </div>
          <div>
            {zone.domain && (
               <span className="inline-block px-2 py-0.5 rounded text-[10px] uppercase tracking-wider font-bold bg-slate-100 text-slate-600 mb-1 border border-slate-200">
                 {zone.domain}
               </span>
            )}
            <h3 className="text-lg font-medium text-gray-900">
              {zone.name}
            </h3>
            <p className="text-sm text-gray-500 font-light">
              {zone.desc}
            </p>
          </div>
        </div>
        
        <div className="flex flex-col items-end shrink-0">
          <div className="text-2xl font-light text-gray-900 tracking-tight whitespace-nowrap">
            {zone.min === 'Rest' || zone.min === 0 ? (
              <span>Up to {zone.max} <span className="text-sm text-gray-500 ml-1 font-normal">bpm</span></span>
            ) : zone.max === 'Max' ? (
              <span>From {zone.min} <span className="text-sm text-gray-500 ml-1 font-normal">bpm</span> and above</span>
            ) : (
              <span>{zone.min} <span className="text-gray-400 mx-1">-</span> {zone.max} <span className="text-sm text-gray-500 ml-1 font-normal">bpm</span></span>
            )}
          </div>
          
          {/* Display range label if provided (for Friel), otherwise calc from range array if available */}
          {zone.rangeLabel ? (
             <div className="text-xs text-gray-400 font-medium tracking-wider uppercase mt-1">
               {zone.rangeLabel}
             </div>
          ) : zone.range ? (
             <div className="text-xs text-gray-400 font-medium tracking-wider uppercase mt-1">
               {Math.round(zone.range[0] * 100)}% - {Math.round(zone.range[1] * 100)}%
             </div>
          ) : null}
        </div>
      </div>
      
      {/* Dynamic background progress indicator */}
      <div 
        className="absolute bottom-0 left-0 h-1 bg-gray-900 opacity-10 transition-all duration-500 group-hover:opacity-20" 
        style={{ width: `${progressWidth}%` }}
      />
    </motion.div>
  );
};

export default ZoneCard;